import { useEffect, useState } from 'react';
import { PRODUCT_SORT } from '../../../api/products';
import { getSections } from '../../../api/store';
import { ProductSection } from '../ProductSection';

function presentId(value) {
  if (value == null || value === '' || value === '0' || value === 0) {
    return '';
  }
  return String(value);
}

function buildMoreLink(section) {
  const params = new URLSearchParams();
  const categoryId = presentId(section.category_id);
  const tagId = presentId(section.tag_id);
  if (categoryId) params.set('category', categoryId);
  if (tagId) params.set('tags', tagId);
  const query = params.toString();
  return query ? `/catalog?${query}` : '/catalog';
}

export function HomeProductSections() {
  const [sections, setSections] = useState([]);

  useEffect(() => {
    getSections()
      .then((data) => {
        const visible = (data.sections || [])
          .filter((section) => section.enabled === true)
          .sort((a, b) => (a.seq_num ?? 0) - (b.seq_num ?? 0));
        setSections(visible);
      })
      .catch(() => setSections([]));
  }, []);

  return (
    <>
      {sections.map((section) => {
        const categoryId = presentId(section.category_id);
        const tagId = presentId(section.tag_id);

        return (
          <ProductSection
            key={`${section.seq_num}-${categoryId}-${tagId}-${section.title}`}
            title={section.title}
            categoryId={categoryId || undefined}
            tagId={tagId || undefined}
            moreLink={buildMoreLink(section)}
            moreLabel={section.more_label}
            limit={Number(section.limit) || 10}
            sort={PRODUCT_SORT.NEW}
          />
        );
      })}
    </>
  );
}
